import { render, staticRenderFns } from "./tentativasEntrega.vue?vue&type=template&id=015960e2"
import script from "./tentativasEntrega.ts?vue&type=script&lang=js&external"
export * from "./tentativasEntrega.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015960e2')) {
      api.createRecord('015960e2', component.options)
    } else {
      api.reload('015960e2', component.options)
    }
    module.hot.accept("./tentativasEntrega.vue?vue&type=template&id=015960e2", function () {
      api.rerender('015960e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/expedicao/tentativasEntrega.vue"
export default component.exports